module.exports = __webpack_public_path__ + "assets/img/tab.02b3a5b8.svg";